import moment from 'moment';
import { getDiscountDays, getDiscountPresentation } from './discountPresentation';

export function getDiscountExtension({ weeklyDiscount, monthlyDiscount, startDate, endDate,
    startTime, endTime, blockedDates = [], maxDay, maxDaysNotice } = {}) {
    const days = getDiscountDays({ startDate, endDate, startTime, endTime });
    const { next } = getDiscountPresentation({ weeklyDiscount, monthlyDiscount }, days);
    if (!next || !days) return null;

    const targetEnd = moment(endDate).clone();
    while (getDiscountDays({ startDate, endDate: targetEnd, startTime, endTime }) < next.days) {
        targetEnd.add(1, 'day');
    }
    const additionalDays = targetEnd.diff(moment(endDate), 'days');
    if (Number(maxDay) > 0 && next.days > Number(maxDay)) return null;
    if (maxDaysNotice === 'unavailable') return null;
    const noticeMonths = { '3months': 3, '6months': 6, '9months': 9, '12months': 12 };
    if (noticeMonths[maxDaysNotice] && targetEnd.isAfter(moment().add(1, 'days').add(noticeMonths[maxDaysNotice], 'months'), 'day')) return null;

    const blocked = new Set(blockedDates.filter(day => day.calendarStatus !== 'available')
        .map(day => moment(day.blockedDates).format('YYYY-MM-DD')));
    for (let date = moment(endDate).clone().add(1, 'day'); date.isSameOrBefore(targetEnd, 'day'); date.add(1, 'day')) {
        if (blocked.has(date.format('YYYY-MM-DD'))) return null;
    }
    return { next, targetEnd, additionalDays };
}
